document.addEventListener('DOMContentLoaded', function () {
  // Get all fuel calculator blocks
  var fuel_calculators = document.getElementsByClassName('evdb-savings-calculator-block'); // Iterate over each fuel calculator block

  Array.prototype.forEach.call(fuel_calculators, function (fuel_calculator) {
    // Get the make and model fields
    var ev_make = fuel_calculator.querySelector('#evdb-fuel-make');
    var ev_model = fuel_calculator.querySelector('#evdb-fuel-model'); // Clone of the model dropdown to reset

    var ev_model_all = fuel_calculator.querySelector('#evdb-fuel-model-clone');
    var results = fuel_calculator.querySelector('.savings-calculator-results'); // Get the submit button and charge/annual toggle

    var submit_button = fuel_calculator.querySelector('.savings-calculator-view-info');
    var type_toggle = fuel_calculator.querySelector('#fuel-calc-charge-or-annual'); // Get the loading spinner

    var loading_spinner = fuel_calculator.getElementsByClassName('loading')[0]; // Define the loading SVG

    var loading_svg = '<svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#40ff7a" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/><path fill="#40ff7a" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20"  dur="0.5s" repeatCount="indefinite"/></path></svg>';
    /**
     * Object containing references to DOM elements used in the fuel calculator.
     */

    var fields = {
      'potential_savings': fuel_calculator.querySelector('#fuel-calc-savings'),
      'off_peak': fuel_calculator.querySelector('#fuel-calc-off-peak'),
      'off_peak_w_solar': fuel_calculator.querySelector('#fuel-calc-off-peak-solar'),
      'petrol': fuel_calculator.querySelector('#petrol'),
      'electric': fuel_calculator.querySelector('#electric'),
      'battery_capacity': fuel_calculator.querySelector('#battery-capacity'),
      'vehicle_preview': fuel_calculator.querySelector('#vehicle-preview')
    };
    /**
     * Triggers fuel calculations by making a POST request to the specified URL.
     * Updates the fields with the response data and handles loading spinner and submit button states.
     */

    function trigger_fuel_calculations() {
      // If we don't have a make or model, don't do anything
      if (ev_model.value === '') {
        // Bail
        return;
      } // Remove the hidden class from the results (if it's there)


      results.classList.remove('!hidden'); // Add the loading spinner and disable the submit button

      loading_spinner.classList.add('active'); // Create a new XMLHttpRequest

      var xhr = new XMLHttpRequest(); // Set the request method and URL

      xhr.open("POST", "/wp-json/laserred/ev/calculator");
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("Content-Type", "application/json"); // When the request is complete

      xhr.onreadystatechange = function () {
        // If we have a response and it's a 200
        if (xhr.readyState === 4 && xhr.status == 200) {
          // Parse the response
          var data = JSON.parse(xhr.responseText); // Add a link to the vehicle

          submit_button.href = data.vehicle.url; // Update the fields

          fields.potential_savings.innerHTML = data.localization.currency + data.savings.with_solar.vs_petrol;
          fields.off_peak.innerHTML = '<span class="block -mb-2" data-type="charge">' + (data.localization.currency + data.off_peak.charge) + '</span><span class="block -mb-2" data-type="annual">' + (data.localization.currency + data.off_peak.annual) + '</span>';
          fields.off_peak_w_solar.innerHTML = '<span class="block -mb-2" data-type="charge">' + (data.localization.currency + data.off_peak_with_solar.charge) + '</span><span class="block -mb-2" data-type="annual">' + (data.localization.currency + data.off_peak_with_solar.annual) + '</span>';
          fields.petrol.innerHTML = data.localization.currency + data.annual_petrol_cost;
          fields.electric.innerHTML = data.localization.currency + data.peak.annual; // Update our decorative fields

          fields.battery_capacity.innerHTML = data.battery_capacity;
          fields.vehicle_preview.href = data.vehicle.url;
          fields.vehicle_preview.innerHTML = loading_svg + '<img src="' + data.vehicle.preview + '" alt="Vehicle preview image" class="relative w-full h-auto aspect-video group-hover:scale-110 transition-transform duration-300 ease-in-out object-cover" />'; // Remove the loading spinner and re-enable the submit button

          loading_spinner.classList.remove('active'); // Remove our disabled attributes

          submit_button.classList.remove('!pointer-events-none');
          submit_button.classList.remove('!opacity-50');
        }
      }; // Send the request


      xhr.send(JSON.stringify({
        'make_model': ev_model.value
      }));
    }
    /**
     * Add an on change event to the make dropdown (we'll then filter the models)
     */


    ev_make.addEventListener('change', function (event) {
      // Get the selected make
      var selected_make = event.target.value; // Reset the model dropdown

      ev_model.innerHTML = ev_model_all.innerHTML; // Get the options

      var options = ev_model.querySelectorAll('option'); // Reset the model dropdown

      ev_model.value = ''; // Enable it (if necessary)

      ev_model.removeAttribute('disabled');

      for (var i = 0; i < options.length; i++) {
        // If the option value isn't our placeholder and doesn't contain the selected make, remove it from our list
        if (options[i].value != '' && !options[i].value.includes(selected_make)) {
          // Bye
          options[i].remove();
        }
      } // Reset our submit button


      submit_button.href = 'javascript:void(0)';
      submit_button.classList.add('!pointer-events-none');
      submit_button.classList.add('!opacity-50');
    });
    /**
     * Add an on change event to the model dropdown (we'll then perform a search)
     */

    ev_model.addEventListener('change', function (event) {
      // Trigger fuel calculations
      trigger_fuel_calculations();
    });
    /**
     * Add an on change event to the charge/annual toggle to switch between the two
     */

    type_toggle.addEventListener('change', function () {
      fuel_calculator.dataset.display = this.checked ? 'annual' : 'charge';
    }); // Trigger fuel calculations on block load (as we have a default)

    trigger_fuel_calculations();
  });
});